import styled from "styled-components";
import { media } from "../../../../utils";

export const SectionHeadline = styled.span`
  text-align: center;
  color: ${({ theme }) => theme.color.neutral["03"]};
  ${media.md()} {
    text-align: left;
    color: #500778;
  }
`;

export const AccordionContainer = styled.div`
  ${media.md()} {
    display: flex;
    justify-content: space-between;

    > div {
      width: 45%;
    }
  }
`;
